import { compose, lifecycle } from 'recompose';
import { connect } from 'react-redux';

import {
  getWaitingListInfoBarberId,
  getWaitingListInfoNumberInLine,
  getWaitingListInfoServiceIds,
  getWaitingListInfoShopId,
} from '../selectors';
import WaitingListInfo from '../components/WaitingListInfo';
import { getServiceDuration, getServiceName } from '../../services/selectors';
import {
  getShopAddress,
  getShopLocation,
  getShopName,
  getShopRoute,
  getShopZip,
} from '../../shops/selectors';
import { clearWaitingListInfo } from '../actions';
import { getBarberName } from '../../barbers/selectors';


const WaitingListInfoContainer = compose(
  connect(
    (state) => {
      const shopId = getWaitingListInfoShopId(state);
      const barberId = getWaitingListInfoBarberId(state);
      const serviceIds = getWaitingListInfoServiceIds(state);

      return {
        barberName: getBarberName(state, barberId),
        serviceName: getServiceName(state, serviceIds),
        serviceDuration: getServiceDuration(state, serviceIds),
        shopName: getShopName(state, getShopRoute(state, shopId)),
        shopAddress: getShopAddress(state, getShopRoute(state, shopId)),
        shopZip: getShopZip(state, getShopRoute(state, shopId)),
        shopLocation: getShopLocation(state, getShopRoute(state, shopId)),
        numberInLine: getWaitingListInfoNumberInLine(state),
      };
    },
    { clearWaitingListInfo },
  ),
  lifecycle({
    componentWillUnmount() {
      this.props.clearWaitingListInfo();
    },
  }),
)(WaitingListInfo);

export default WaitingListInfoContainer;



// WEBPACK FOOTER //
// ./src/app/waitingList/containers/WaitingListInfo.js